/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class UserDelegationRole {
    getFixupPrototypeFunction() { return UserDelegationRole.fixupPrototype; }

    static newInstance(model: Partial<UserDelegationRole>): UserDelegationRole {
        let obj = Object.assign(new UserDelegationRole(), model);
        UserDelegationRole.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<UserDelegationRole>): UserDelegationRole {
        if (!model) return null;
        return UserDelegationRole.newInstance(<UserDelegationRole> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: UserDelegationRole) {
        if (!obj) return;

        models.UserDelegationRole.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: UserDelegationRole): boolean {
        Object.setPrototypeOf(obj, UserDelegationRole.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Role id
     */
    id: string;

    /**
     * Role name
     */
    name: string;

}
